import { sepAPI } from '../API/sepAPI';
import {
  SepPromptPreviewRequest,
  SepPromptPreviewResponse,
  SepPromptSetting,
  SepPromptSettingHistoryItem,
  SepPromptSettingsResponse,
  SepPromptSettingValues,
} from '../../../shared/types/SepPromptSetting';

export const DEFAULT_SEP_PROMPT_SETTINGS: SepPromptSettingValues = {
  systemPrompt:
    'You are a technical requirements analyst writing concise internal summaries for a Solution Enablement Process (SEP) intake system at Constellation. ' +
    'Write a concise plain-text summary using only details explicitly provided in the request title, description, and intake responses. ' +
    'Use one sentence per line, with up to 4 sentences. Include only meaningful details that have an actual value. ' +
    'Do not mention missing, unavailable, unspecified, or unprovided information, and do not say that more information is needed. ' +
    'Do not infer or invent details from the absence of a response. If only one or two meaningful details are provided, write only one or two sentences. ' +
    'Rules: No bullets, no markdown, no headers, never echo raw field names, never repeat the title verbatim, Do not include primary or request contact details.',
  includeDescription: true,
  includeIntakeResponses: true,
  includeAttachments: true,
};

export const sepPromptSettingsSlice = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    getSepPromptSettings: builder.query<SepPromptSettingsResponse, void>({
      query: () => 'admin/sep-prompt-settings',
      providesTags: ['SepPromptSettings'],
    }),
    updateSepPromptSettings: builder.mutation<
      SepPromptSetting,
      SepPromptSettingValues
    >({
      query: (body) => ({
        url: 'admin/sep-prompt-settings',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['SepPromptSettings', 'SepPromptSettingsHistory'],
    }),
    getSepPromptSettingsHistory: builder.query<
      SepPromptSettingHistoryItem[],
      void
    >({
      query: () => 'admin/sep-prompt-settings/history',
      providesTags: ['SepPromptSettingsHistory'],
    }),
    resetSepPromptSettings: builder.mutation<SepPromptSetting, void>({
      query: () => ({
        url: 'admin/sep-prompt-settings/reset',
        method: 'POST',
      }),
      invalidatesTags: ['SepPromptSettings', 'SepPromptSettingsHistory'],
    }),
    previewSepPromptSettings: builder.mutation<
      SepPromptPreviewResponse,
      SepPromptPreviewRequest
    >({
      query: (body) => ({
        url: 'admin/sep-prompt-settings/preview',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetSepPromptSettingsQuery,
  useUpdateSepPromptSettingsMutation,
  useGetSepPromptSettingsHistoryQuery,
  useResetSepPromptSettingsMutation,
  usePreviewSepPromptSettingsMutation,
} = sepPromptSettingsSlice;